module.exports = __webpack_public_path__ + "images/emoji/no_entry_sign.711f1a1968e471baba79.png";